/* eslint-disable no-debugger */
import { Fragment } from 'react';

import useClubMeetApprovedRequest from './UseClubMeetApprovedRequest';

import MeetApprovedInfoForm from './forms/MeetApprovedInfoForm';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Headings from '@usas/ui-web/components/headings/Headings';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import SessionsGrid from '@usas/ui-web/components/meetSessions/SessionsGrid';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import Constants from '@usas/ui-web/utils/Constants';
import global from '@usas/ui-web/components/GlobalStyle.module.css'
import MeetApprovedSessionDetailForm from './forms/MeetApprovedSessionDetailForm';

const ClubMeetApprovedRequest = () => {
  const {
    isSaving,
    isLoading, 
    formState,
    errorState,
    setFormState,
    setIsDirty,
    handleSubmitProxy,
    onFormValueChanged,
    onValueTextPairChanged,
    meetState,
    displayMeetInfoFormState,
    displayMeetSessionsFormState,
    displayMeetSessionsDetailFormState,
    displayStaffFormState,
    meetInfoState,
    meetSessionsState,
    facilityOptionsState,
    orgUnitId,
    onSessionsFormSubmit,
    onRequestSubmit,
    onBackToMeetInfoClicked,
    onBackToMeetSessionsFromDetail,
    onAddSession,
    onEditSession,
    onDeleteSession,
    onDeleteSessionClicked,
    onModalCanceled,
    onCancelClicked,
    state,
    setState,
    hasUsasSanctionAccess
  } = useClubMeetApprovedRequest();

  return (
    <Fragment>
        {displayMeetInfoFormState === true &&
          <Fragment>
            <div className="row">
              <div className="col-xs-12">
                <Headings.H3>Approved Meet Request - Meet Info</Headings.H3>
              </div>
            </div>
            <MeetApprovedInfoForm
              handleSubmitProxy={handleSubmitProxy}
              onFormValueChanged={onFormValueChanged}
              onValueTextPairChanged={onValueTextPairChanged}
              formState={formState}
              errorState={errorState}
              setFormState={setFormState}
              setIsDirty={setIsDirty}
              savedFormState={meetInfoState}
              clubFacilities={facilityOptionsState}
              orgUnitId={orgUnitId}
              onCancelClicked={onCancelClicked}
              state={state}
              setState={setState}
              meetState={meetState}
              hasUsasSanctionAccess={hasUsasSanctionAccess}
            />
          </Fragment>
        }
        {displayMeetSessionsFormState === true &&
          <Fragment>
            <div className="row">
              <div className="col-xs-12">
                <Headings.H3>Approved Meet Request - Sessions</Headings.H3>
              </div>
            </div>
            <div className='row'>
              <div className='col-xs-12 usas-extra-top-margin'>
                <ActionIntraPageButton onClick={onAddSession}>Add Session</ActionIntraPageButton>
              </div>
              <div className='col-xs-12 usas-extra-bottom-margin'>
                <SessionsGrid
                  showOptionalFields={false}
                  sortedMeetSessionArray={meetSessionsState.sortedMeetSessionArray}
                  onEdit={onEditSession}
                  onDelete={onDeleteSession}
                  onDeleteClicked={onDeleteSessionClicked}
                />
              </div>
            </div>
            {meetSessionsState.errorState?.error &&
              <div className="row">
                <div className="col-xs-12">
                  <p className={global.ErrorMessage}>{meetSessionsState.errorState?.error ? meetSessionsState.errorState?.error : ''}</p>
                </div>
              </div>
            }
            <div className="row">
              <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
                <PrimaryButton type="button" onClick={() => onSessionsFormSubmit()}>Continue</PrimaryButton>&nbsp;
                <SecondaryButton type="button" onClick={() => onBackToMeetInfoClicked()}>Back</SecondaryButton>
              </div>
            </div>
            <PopUpModal
              widthPct={90}
              maxWidth={720}
              title={meetSessionsState?.modalState?.modalTitle}
              displayPopUp={meetSessionsState?.modalState?.displayPopUp}
              onModalCanceled={onModalCanceled}>
              <div className="row">
                <div className="col-xs-12">
                  <p><b>Session Number:</b>&nbsp;{meetSessionsState?.modalState?.sessionOrderId}</p>
                  <p><b>Session Type:</b>&nbsp;{meetSessionsState?.modalState?.sessionTypeName}</p>
                  <p><b>Session Date:</b>&nbsp;{meetSessionsState?.modalState?.sessionDate ? formatDate(meetSessionsState?.modalState?.sessionDate) : ''}</p>
                </div>
                <div className="col-xs-12 usas-extra-top-margin">
                  <PrimaryButton type="button" onClick={(e) => onDeleteSession(e, meetSessionsState?.modalState?.meetSessionId)}>Delete</PrimaryButton>&nbsp;
                  <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>
                </div>
              </div>
            </PopUpModal>
          </Fragment>
        }
        {displayMeetSessionsDetailFormState === true &&
          <Fragment >
            <div className="row">
              <div className="col-xs-12">
                <Headings.H3>Meet Sanction Request - {meetSessionsState.formState.meetSessionId > 0 ? 'Edit' : 'Add'} Session</Headings.H3>
              </div>
            </div>
            <MeetApprovedSessionDetailForm
              onBackToMeetSessions={onBackToMeetSessionsFromDetail}
            />
          </Fragment>}
        {displayStaffFormState === true &&
          <Fragment>
            <div className="row">
              <div className="col-xs-12">
                <p>In granting this approval it is understood and agreed that USA Swimming shall be free from any liabilities or claims for damages arising by reason of injuries to anyone during the conduct of the event.</p>
                <PrimaryButton type="button" onClick={(e) => onRequestSubmit()}>Submit Request</PrimaryButton>&nbsp;
              </div>
            </div>
          </Fragment>
        }
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title="Submitting Request..."
        displayPopUp={isSaving} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment >
  );
};

export default ClubMeetApprovedRequest;